var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('br'),_c('h2',{staticClass:"font-weight-bold text-lg-center display-1"},[_vm._v(_vm._s(_vm.message))]),_c('v-card-text',[_vm._v(" Begins at: "+_vm._s(_vm.begins)),_c('br'),_vm._v(" "+_vm._s(_vm.countdown)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }